import { IAppointmentProductBase } from '../../models/appointments';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListAppointmentProductProps {
  appointmentId: string;
  name?: string;
  sort?: 'price' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export type IAppointmentProductListItem = IAppointmentProductBase;

export type IAppointmentProductList =
  IListResponse<IAppointmentProductListItem>;

export const listAppointmentProductsService = async ({
  appointmentId,
  ...filters
}: IListAppointmentProductProps): Promise<IAppointmentProductList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IAppointmentProductList>(
    `/appointments/${appointmentId}/products`,
    {
      params,
    },
  );

  return data;
};
